// extracted by mini-css-extract-plugin
export default {"buttonContainer":"PostFooter_buttonContainer__r-NX2","btn":"PostFooter_btn__M52Yl"};